import { FC } from 'react'
import { Link } from 'react-router-dom'
import { RetroButton } from '@/components/retro'

export const TermsScreen: FC = () => {
  return (
    <div className="min-h-screen bg-game-bg p-4">
      <div className="max-w-3xl mx-auto">
        {/* Header */}
        <div className="flex items-center justify-between mb-6">
          <h1 className="font-pixel text-xl text-game-accent">TERMS OF SERVICE</h1>
          <Link to="/">
            <RetroButton variant="default" size="sm">BACK</RetroButton>
          </Link>
        </div>

        {/* Content */}
        <div className="border-2 border-game-border bg-game-panel p-6 space-y-6">
          <p className="font-retro text-sm text-game-muted">
            Last Updated: January 30, 2025
          </p>

          <section className="space-y-3">
            <h2 className="font-pixel text-base text-game-accent">1. ACCEPTANCE OF TERMS</h2>
            <p className="font-retro text-base text-game-text leading-relaxed">
              Welcome to Trench Quest. By accessing or using our application, you agree to be bound by these Terms of Service ("Terms"). If you do not agree to these Terms, please do not use the App.
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="font-pixel text-base text-game-accent">2. DESCRIPTION OF SERVICE</h2>
            <p className="font-retro text-base text-game-text leading-relaxed">
              Trench Quest is a simulation game that provides an entertaining, fictional experience based on cryptocurrency trading culture. The game features AI-generated narratives, simulated market conditions, and fictional scenarios for entertainment purposes only.
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="font-pixel text-base text-game-accent">3. ELIGIBILITY</h2>
            <p className="font-retro text-base text-game-text leading-relaxed">
              You must be at least 18 years old to use Trench Quest. By using the App, you represent and warrant that you meet this age requirement and have the legal capacity to enter into these Terms.
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="font-pixel text-base text-game-accent">4. ACCOUNT AND WALLET</h2>
            <p className="font-retro text-base text-game-text leading-relaxed">
              To save your progress, you must connect a Solana wallet and sign a message to verify ownership. You are responsible for maintaining the security of your wallet. We are not responsible for any loss resulting from unauthorized access to your wallet.
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="font-pixel text-base text-game-accent">5. NOT FINANCIAL ADVICE</h2>
            <div className="p-4 border-2 border-game-loss bg-game-loss/10">
              <p className="font-retro text-base text-game-text leading-relaxed">
                <strong>CRITICAL DISCLAIMER:</strong> Trench Quest is a GAME. It is NOT financial advice, investment guidance, or a trading recommendation. All content is fictional and for entertainment only. Do NOT make real financial decisions based on anything in this game.
              </p>
            </div>
            <ul className="font-retro text-base text-game-text leading-relaxed list-disc list-inside space-y-1">
              <li>We are not a registered investment advisor</li>
              <li>We do not provide financial, legal, or tax advice</li>
              <li>Simulated results do not predict real-world outcomes</li>
              <li>Always consult qualified professionals for financial decisions</li>
              <li>Never invest more than you can afford to lose</li>
            </ul>
          </section>

          <section className="space-y-3">
            <h2 className="font-pixel text-base text-game-accent">6. ACCEPTABLE USE</h2>
            <p className="font-retro text-base text-game-text leading-relaxed">
              You agree to use the App only for lawful purposes and in accordance with these Terms. You agree NOT to:
            </p>
            <ul className="font-retro text-base text-game-text leading-relaxed list-disc list-inside space-y-1">
              <li>Violate any applicable laws or regulations</li>
              <li>Infringe upon the rights of others</li>
              <li>Transmit harmful code or malware</li>
              <li>Attempt to interfere with the App's operation</li>
              <li>Collect user data without authorization</li>
              <li>Use the App for commercial purposes without permission</li>
              <li>Create multiple accounts to abuse game mechanics</li>
            </ul>
          </section>

          <section className="space-y-3">
            <h2 className="font-pixel text-base text-game-accent">7. CONTENT AND MATURE THEMES</h2>
            <p className="font-retro text-base text-game-text leading-relaxed">
              Trench Quest contains mature themes including but not limited to:
            </p>
            <ul className="font-retro text-base text-game-text leading-relaxed list-disc list-inside space-y-1">
              <li>Strong language and crude humor</li>
              <li>References to alcohol and substance use</li>
              <li>Suggestive and adult situations</li>
              <li>Gambling themes (simulated)</li>
              <li>Satirical depictions of financial speculation</li>
              <li>Dark humor about addiction and loss</li>
            </ul>
            <p className="font-retro text-base text-game-text leading-relaxed">
              This content is intended for mature audiences only. If you find such content objectionable, please do not use the App.
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="font-pixel text-base text-game-accent">8. AI-GENERATED CONTENT</h2>
            <p className="font-retro text-base text-game-text leading-relaxed">
              Trench Quest uses artificial intelligence to generate game content including narratives, characters, and scenarios. This content is procedurally generated and may occasionally produce unexpected results. We do not endorse or guarantee the accuracy of AI-generated content.
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="font-pixel text-base text-game-accent">9. INTELLECTUAL PROPERTY</h2>
            <p className="font-retro text-base text-game-text leading-relaxed">
              All content, features, and functionality of the App are owned by Trench Quest and are protected by intellectual property laws. You may not reproduce, distribute, or create derivative works without our express written permission.
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="font-pixel text-base text-game-accent">10. THIRD-PARTY REFERENCES</h2>
            <p className="font-retro text-base text-game-text leading-relaxed">
              The App may reference real cryptocurrencies, projects, or public figures for satirical and entertainment purposes. These references are parody and commentary protected by fair use. We are not affiliated with any referenced third parties unless explicitly stated.
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="font-pixel text-base text-game-accent">11. DISCLAIMERS</h2>
            <p className="font-retro text-base text-game-text leading-relaxed">
              THE APP IS PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTIES OF ANY KIND. WE DISCLAIM ALL WARRANTIES, INCLUDING MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT. WE DO NOT WARRANT THAT THE APP WILL BE UNINTERRUPTED, SECURE, OR ERROR-FREE.
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="font-pixel text-base text-game-accent">12. LIMITATION OF LIABILITY</h2>
            <p className="font-retro text-base text-game-text leading-relaxed">
              TO THE FULLEST EXTENT PERMITTED BY LAW, TRENCH QUEST SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, INCLUDING LOSS OF PROFITS, DATA, OR GOODWILL, ARISING FROM YOUR USE OF THE APP.
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="font-pixel text-base text-game-accent">13. INDEMNIFICATION</h2>
            <p className="font-retro text-base text-game-text leading-relaxed">
              You agree to indemnify, defend, and hold harmless Trench Quest and its officers, directors, employees, and agents from any claims, liabilities, damages, costs, or expenses arising from your use of the App or violation of these Terms.
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="font-pixel text-base text-game-accent">14. MODIFICATIONS</h2>
            <p className="font-retro text-base text-game-text leading-relaxed">
              We reserve the right to modify these Terms at any time. We will provide notice of material changes by updating the "Last Updated" date. Your continued use of the App after changes constitutes acceptance of the modified Terms.
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="font-pixel text-base text-game-accent">15. TERMINATION</h2>
            <p className="font-retro text-base text-game-text leading-relaxed">
              We may terminate or suspend your access to the App at our sole discretion, without notice, for any reason including violation of these Terms. Upon termination, your right to use the App ceases immediately.
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="font-pixel text-base text-game-accent">16. GOVERNING LAW</h2>
            <p className="font-retro text-base text-game-text leading-relaxed">
              These Terms shall be governed by the laws of the State of Delaware, United States, without regard to its conflict of law provisions.
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="font-pixel text-base text-game-accent">17. DISPUTE RESOLUTION</h2>
            <p className="font-retro text-base text-game-text leading-relaxed">
              Any disputes arising from these Terms shall be resolved through binding arbitration in accordance with the rules of the American Arbitration Association. You waive any right to participate in class action lawsuits.
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="font-pixel text-base text-game-accent">18. SEVERABILITY</h2>
            <p className="font-retro text-base text-game-text leading-relaxed">
              If any provision of these Terms is found to be unenforceable, the remaining provisions shall continue in full force and effect.
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="font-pixel text-base text-game-accent">19. CONTACT US</h2>
            <p className="font-retro text-base text-game-text leading-relaxed">
              For questions about these Terms, please contact us at:
            </p>
            <p className="font-retro text-base text-game-accent">
              legal@trenchquest.com
            </p>
          </section>

          {/* Copyright Notice */}
          <section className="space-y-3 pt-6 border-t border-game-border">
            <h2 className="font-pixel text-base text-game-accent">COPYRIGHT NOTICE</h2>
            <p className="font-retro text-base text-game-text leading-relaxed">
              Copyright 2025 Trench Quest. All rights reserved.
            </p>
            <p className="font-retro text-base text-game-text leading-relaxed">
              Trench Quest and its logo are trademarks of Trench Quest. All other trademarks, logos, and brand names are the property of their respective owners and are used for identification and satire purposes only.
            </p>
            <p className="font-retro text-base text-game-text leading-relaxed">
              The game's use of cryptocurrency names, public figures, and project references constitutes fair use parody and commentary. No endorsement or affiliation is implied.
            </p>
          </section>

          {/* Footer */}
          <div className="pt-6 border-t border-game-border text-center">
            <p className="font-retro text-sm text-game-muted">
              NFA. DYOR. WAGMI (or not - it's just a game).
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}
